export interface AppDrawerTab {
  value: string | number
  label: string
}

export type AppDrawerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export const DRAWER_SIZES = Object.freeze({
  xs: '400',
  sm: '460',
  md: '640',
  lg: '800',
  xl: '960',
})
